import React from 'react';
import { CommissionCalculator, CommissionViewer } from '../features/commissions';

const CommissionsPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Commission Management</h1>
          <p className="text-gray-600">Calculate and view agent commissions</p>
        </div>

        <div className="space-y-6">
          <CommissionCalculator />
          <CommissionViewer />
        </div>
      </div>
    </div>
  );
};

export default CommissionsPage;
